import { useAuthStore } from '@/stores/authStore';

export const checkToken = async () => {
    const store = useAuthStore();
    await store.checkTokenExpiration();
};